import {
  CustomTheme,
  lighten,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useTheme,
} from '@mui/material';
import React from 'react';
import { IMenuItem } from './interfaces';

export const MenuItem: React.FC<IMenuItem> = ({
  key,
  label,
  hint,
  icon,
  onClick,
  active = false,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  return (
    <Tooltip title={hint} placement="right" enterDelay={1500} arrow>
      <ListItem
        key={key}
        sx={{
          color: active
            ? theme.palette.getContrastText(theme.palette.primary.main)
            : theme.portal.sidebar.textColor,
          '&:not(:last-child)': {
            mb: '5px',
          },
        }}
        disablePadding
      >
        <ListItemButton
          sx={{
            '&.Mui-selected': {
              backgroundColor: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
              },
            },
            '&:hover': {
              backgroundColor: lighten(theme.portal.sidebar.background, 0.09),
            },
            borderRadius: '8px',
            paddingY: '2px',
            paddingX: '12px',
            // mx: '5px',
          }}
          selected={active}
          onClick={onClick}
        >
          <ListItemIcon
            sx={{
              minWidth: '31px',
              '& svg': {
                fontSize: '20px',
                color: active
                  ? theme.palette.getContrastText(theme.palette.primary.main)
                  : theme.portal.sidebar.textColor,
              },
            }}
          >
            {icon}
          </ListItemIcon>
          <ListItemText
            primary={label}
            primaryTypographyProps={{
              fontSize: 14,
              fontWeight: 'bold',
            }}
          />
        </ListItemButton>
      </ListItem>
    </Tooltip>
  );
};
